'use strict';

var React = require('react');
var ResizeObserver = require('resize-observer-polyfill');
var functions = require('../helpers/functions.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var ResizeObserver__default = /*#__PURE__*/_interopDefaultCompat(ResizeObserver);

const RESIZE_OBSERVE_DEBOUNCE_TIME_MS = 150;
const useResizeObserver = ({ elementRefs, observer }) => {
    // Debounce Observer Function - In order to fix warning : ResizeObserver - loop limit exceeded
    const resizeObserver = React.useMemo(() => new ResizeObserver__default.default(functions.debounce(RESIZE_OBSERVE_DEBOUNCE_TIME_MS)(observer)), [observer]);
    React.useEffect(() => {
        const elements = elementRefs.map(elementRef => elementRef.current).filter(Boolean);
        elements.forEach(element => resizeObserver.observe(element));
        return () => resizeObserver.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resizeObserver, ...elementRefs]);
};

exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=useResizeObserver.js.map
